// extracted by mini-css-extract-plugin
export default {"appDetails":"AppDetails_appDetails__ceWHN","info":"AppDetails_info__FnYkb","stars":"AppDetails_stars__K1VXx"};